import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'

type Args = {
  linkId: string
}

export const useDeleteLink = () => {
  const queryClient = useQueryClient()

  return useMutation<{ success: boolean }, Error, Args>({
    mutationFn: async ({ linkId }) => {
      const { data } = await api.delete(`/links/${linkId}`)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['all-links'] })
    },
  })
}
